import React from 'react';
import {connect} from "react-redux";
import Icon from "../../../../../../../../../../../../components/icon";
import {
    commentContentToAdd,
    parseContactOnCommentToAdd
} from "../../../../../../../../../../../../../actions/commentActions";
import {
    commentToAddContactSearchResult,
    resetCommentToAddContactSearchResult
} from "../../../../../../../../../../../../../actions/contactActions";
import './index.css';

function CommentToAddAutoComplete (props) {

    const {
        isSearchingContacts,
        commentToAddContactSearchResult,
        commentContentToAdd,
        setCommentContentToAdd,
        setParseContactOnCommentToAdd,
        resetCommentToAddContactSearchResult
    } = props;

    const clickHandler = (e) => {
        setCommentContentToAdd(commentContentToAdd.replace(/@\w+$/g, '@' + e.currentTarget.dataset.contactEmail));
        resetCommentToAddContactSearchResult();
        setParseContactOnCommentToAdd(null);
        e.currentTarget.parentElement.parentElement.children[0].value = e.currentTarget.parentElement.parentElement.children[0].value.replace(/@\w+$/g, '@' + e.currentTarget.dataset.contactEmail);
        e.currentTarget.parentElement.parentElement.children[0].focus();
    }

    return (
        <div className="comment-to-add-autocomplete">
            {
                isSearchingContacts === false
                    ?
                    commentToAddContactSearchResult.map((item) => (
                        <div key={item.id} onClick={clickHandler} data-contact-email={item.email} className="d-flex contact px-3 py-2">
                            <div>
                                <p className="mb-0"><strong>{item.name}</strong></p>
                                <p className="mb-0">{item.email}</p>
                            </div>
                        </div>
                    ))
                    :
                    <div className="p-3">
                        <Icon animated={'pulse'} name="spinner"/>
                    </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        commentToAddContactSearchResult: state.contactReducer.commentToAddContactSearchResult,
        isSearchingContacts: state.contactReducer.isSearchingContacts,
        commentContentToAdd: state.commentReducer.commentContentToAdd
    };
};

const mapDispatchToProps = (dispatch) => ({
    setCommentContentToAdd: (string) => dispatch(commentContentToAdd(string)),
    setCommentToAddContactSearchResult: (string) => dispatch(commentToAddContactSearchResult(string)),
    setParseContactOnCommentToAdd: (array) => dispatch(parseContactOnCommentToAdd(array)),
    resetCommentToAddContactSearchResult: () => dispatch(resetCommentToAddContactSearchResult()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentToAddAutoComplete);
